import { Link } from '@provider/navigation';
import { PostloadedImage } from '@utils/react';
import { wrapper, imageCls, link, linkSurface } from './Slide.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Slide(props) {
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    style: {
      left: `${props.index * 100}%`
    },
    children: [/*#__PURE__*/jsx(PostloadedImage, {
      className: imageCls,
      src: props.model.image.src,
      width: props.model.image.width,
      height: props.model.image.height,
      alt: "",
      loading: props.isCurrent ? "eager" : "lazy",
      sizes: "min(100vw, 700px)"
    }), /*#__PURE__*/jsx(SlideLink, {
      link: props.model.link
    })]
  });
}
function SlideLink(props) {
  if (!props.link) {
    return null;
  }
  return /*#__PURE__*/jsx(Link, {
    href: props.link.href,
    target: props.link.target,
    className: link,
    style: linkSurface.__override({
      color: props.link.color,
      background: props.link.background
    }),
    children: props.link.label
  });
}

export { Slide };
//# sourceMappingURL=Slide.js.map
